import { Typography } from 'antd'
import { ColumnsType } from 'antd/es/table'
import React, { useMemo } from 'react'

import { ChatterOverviewStatisticsEmployee } from '@/model/analytics'
import {
  formatPercentage,
  formatPrice,
  formatDurationToH_M_S,
} from '@/utils/formatter'

const { Text } = Typography

function renderRatio(value: number) {
  return <Text type={value >= 0 ? 'success' : 'danger'}>{formatPercentage()(value)}</Text>
}

export const useChatterOverviewStatisticsColumns = () => useMemo((): ColumnsType<ChatterOverviewStatisticsEmployee> => [
  {
    title: 'Employees',
    dataIndex: 'name',
    key: 'name',
    sorter: (a, b) => a.name.localeCompare(b.name),
  },
  {
    title: 'Sales',
    dataIndex: 'sales',
    key: 'sales',
    width: 150,
    sorter: (a, b) => a.sales - b.sales,
    render: (value: number) => (
      formatPrice()(value)
    ),
  },
  {
    title: 'Messages sent',
    dataIndex: 'messageSent',
    key: 'messageSent',
    render(value) {
      return `${value ?? 0}`
    },
  },
  {
    title: 'Tips',
    dataIndex: 'tipsTotal',
    key: 'tipsTotal',
    width: 120,
    render(value) {
      return formatPrice()(value)
    },
  },
  {
    title: 'Posts',
    dataIndex: 'postsTotal',
    key: 'postsTotal',
    width: 120,
    render(value) {
      return formatPrice()(value)
    },
  },
  {
    title: 'PPVs sent',
    dataIndex: 'ppvsSent',
    key: 'ppvsSent',
    render(value) {
      return `${value ?? 0}`
    },
  },
  {
    title: 'PPVs unlocked',
    dataIndex: 'ppvsUnlocked',
    key: 'ppvsUnlocked',
    render(value) {
      return `${value ?? 0}`
    },
  },
  {
    title: 'Golden ratio',
    dataIndex: 'goldenRatio',
    key: 'goldenRatio',
    render: renderRatio,
  },
  {
    title: 'Unlock ratio',
    dataIndex: 'unlockRatio',
    key: 'unlockRatio',
    render: renderRatio,
  },
  {
    title: 'Fans chatted',
    dataIndex: 'fansChatted',
    key: 'fansChatted',
    render(value) {
      return `${value ?? 0}`
    },
  },
  {
    title: 'Keystrokes(words)',
    dataIndex: 'keystrokes',
    key: 'keystrokes',
    render(value) {
      return `${value ?? 0}`
    },
  },
  {
    title: 'Reply time',
    dataIndex: 'replyTime',
    key: 'replyTime',
    render: formatDurationToH_M_S(),
  },
  {
    title: 'Scheduled hours',
    dataIndex: 'scheduledHours',
    key: 'scheduledHours',
    render(value) {
      return `${value ?? 0}h`
    },
  },
], [])
